import api from "./api";

// Función que obtiene los recursos desde el backend
export const fetchPlanetResources = async (playerId) => {
  const data = await api.get(`/api/resources/${playerId}`); // endpoint real
  return data;
};